import React, { Component } from 'react';

import $ from 'jquery';

import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import Input from 'react-validation/build/input';
import { required } from '../../../formValidation';
import { FormGroup, Label, UncontrolledTooltip } from 'reactstrap';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/fontawesome-free-solid';

import yotubeFieldsToCopy from '../../../../images/dashboard/youtube-stream-url.jpg';

import '../../../../styles/common-form-styles.css';

import './YoutubeStreamForm.css';

class YoutubeStreamForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    
    this.addYoutube =this.addYoutube.bind(this);
  }

  addYoutube(e) {
    // TODO validate youtube url
    e.preventDefault();
    const formVal = this.form.getValues();
    let rtmpUrl = formVal.youtubeRtmpUrl;
    let host = rtmpUrl.substring(rtmpUrl.indexOf("/"),rtmpUrl.lastIndexOf("/")).replace("//","")
    let application = rtmpUrl.substring(rtmpUrl.lastIndexOf("/")+1,rtmpUrl.length)
 
    $.ajax({
      method: 'POST',
      url: '/api/v1/social/media',
      data: JSON.stringify({
        email: this.props.user.profileObj.email,
        name: this.props.user.profileObj.name,
        type: 'YOUTUBE',
        host:host,
        application:application,
        youtubeKey:formVal.youtubeKey,
        access_token:this.props.user.Zi.access_token
      
      }),
      success: function (success) {
    
        this.props.updateYoutubeLogin(success.response, this.props.user);
        this.props.notifySuccess(success.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {
    return (
      <Form className="YoutubeStreamForm" ref={c => { this.form = c }} onSubmit={this.addYoutube}>
        <span onClick={this.props.toggleModal} className="closeModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
        <h2 className="formTitle text-center">{this.props.t("Youtube_Stream_Information")}</h2>

        <FormGroup>
          <Label for="youtubeURL" className="text-white mr-sm-2">{this.props.t("Server_URL")}</Label>
          <Input type="text" name="youtubeRtmpUrl" t={this.props.t} id="youtubeURL" className="form-control"
            validations={[required]} />
        </FormGroup>

        <FormGroup>
          <Label for="youtubeRtmpSecret" className="text-white mr-sm-2">{this.props.t("Stream_Key")}</Label>
          <Input type="text" name="youtubeKey"  t={this.props.t} id="youtubeKey" className="form-control" 
            validations={[required]} />
        </FormGroup>

        <FormGroup className="clearfix">
          <span className="float-right text-white">
            <FontAwesomeIcon id="youtube-fields-info" className="youtube-fields-info-icon mr-2" icon={faInfoCircle} />
            <UncontrolledTooltip placement="top" target="youtube-fields-info">
              <img className="img-fluid" src={yotubeFieldsToCopy} alt="youtube fields required" />
            </UncontrolledTooltip>
            <a href="https://www.youtube.com/my_live_events" target="_blank" rel="noopener noreferrer">{this.props.t("Click_here_to_get_URL_and_Key")}</a>.
          </span>
        </FormGroup>

        <div className="form-group submitGroup form-row text-center">
          <Button type="submit" className="btn btn--submit btn-rounded btn-outline-primary mx-auto">{this.props.t("SUBMIT")}</Button>
        </div>
      </Form>
    );
  }
}

export default YoutubeStreamForm;



// WEBPACK FOOTER //
// ./src/components/DashboardPage/SocialMedia/YoutubeStreamForm/YoutubeStreamForm.js